import { render, staticRenderFns } from "./EtapaMRA.vue?vue&type=template&id=f839f5fe&scoped=true&lang=pug"
import script from "./EtapaMRA.vue?vue&type=script&lang=js"
export * from "./EtapaMRA.vue?vue&type=script&lang=js"
import style0 from "./EtapaMRA.vue?vue&type=style&index=0&id=f839f5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f839f5fe",
  null
  
)

export default component.exports